import { extendObservable } from 'mobx';
import axios from '../../../libs/axios_csrf';

export default class Get {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.fetchData();

    extendObservable(this, {
      dataStartups: [],
      dataUsers: [],
      loaded: false,
    });
  }

  fetchData() {
    axios.get('/startup_statistics/action_manager/get')
      .then((response) => {
        this.dataStartups = response.data.new_startups;
        this.dataUsers = response.data.new_users;
        this.loaded = true;
      })
      .catch((error) => {
        console.log('An error happened!', error);
      });
  }
}
